import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import { Toaster } from "./components/ui/sonner";
import AnalyticsTracker from "./components/AnalyticsTracker";
import VisitorTracker from "./components/VisitorTracker";
import AnalyticsScripts from "./components/AnalyticsScripts";
import "./App.css";

// Import pages
import HomePage from "./pages/HomePage";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminTariffs from "./pages/admin/AdminTariffs";
import AdminBlog from "./pages/admin/AdminBlog";
import AdminSettings from "./pages/admin/AdminSettings";
import AdminContent from "./pages/admin/AdminContent";
import AdminTestimonials from "./pages/admin/AdminTestimonials";
import AdminFAQ from "./pages/admin/AdminFAQ";
import AdminStatistics from "./pages/admin/AdminStatistics";
import AdminSystem from "./pages/admin/AdminSystem";
import AdminFeatures from "./pages/admin/AdminFeatures";
import AdminProfile from "./pages/admin/AdminProfile";
import TariffsPage from "./pages/TariffsPage";
import BlogPage from "./pages/BlogPage";
import BlogPostPage from "./pages/BlogPostPage";
import PartnerProgramPage from "./pages/PartnerProgramPage";
import SupportPage from "./pages/SupportPage";
import LegalPage from "./pages/LegalPage";
import NotFoundPage from "./pages/NotFoundPage";
import ScrollToTop from "./components/ScrollToTop";

// Admin layout wrapper
import AdminLayout from "./components/admin/AdminLayout";

// Auth context
import { AuthProvider } from "./contexts/AuthContext";

function App() {
  return (
    <div className="App">
      <HelmetProvider>
        <AuthProvider>
          <BrowserRouter>
            <AnalyticsTracker />
            <VisitorTracker />
            <AnalyticsScripts />
            <ScrollToTop />
            <Routes>
            {/* Public routes */}
            <Route path="/" element={<HomePage />} />
            <Route path="/tariffs" element={<TariffsPage />} />
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/blog/:postId" element={<BlogPostPage />} />
            <Route path="/partner-program" element={<PartnerProgramPage />} />
            <Route path="/support" element={<SupportPage />} />
            <Route path="/privacy" element={<LegalPage type="privacy" />} />
            <Route path="/terms" element={<LegalPage type="terms" />} />
            
            {/* Admin routes */}
            <Route path="/admin" element={<Navigate to="/admin/login" />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            
            {/* Protected admin routes */}
            <Route path="/admin" element={<AdminLayout />}>
              <Route path="dashboard" element={<AdminDashboard />} />
              <Route path="content" element={<AdminContent />} />
              <Route path="features" element={<AdminFeatures />} />
              <Route path="tariffs" element={<AdminTariffs />} />
              <Route path="blog" element={<AdminBlog />} />
              <Route path="testimonials" element={<AdminTestimonials />} />
              <Route path="faq" element={<AdminFAQ />} />
              <Route path="statistics" element={<AdminStatistics />} />
              <Route path="system" element={<AdminSystem />} />
              <Route path="settings" element={<AdminSettings />} />
              <Route path="profile" element={<AdminProfile />} />
            </Route>
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </BrowserRouter>
        <Toaster />
      </AuthProvider>
    </HelmetProvider>
    </div>
  );
}

export default App;
